export interface CollectionProduct {
  id: number
  brand: string
  name: string
  description: string
  material: string
  price: string
  images: string[]
  status: string
  // Legacy support - will use first image from images array
  image?: string
}

export type CollectionStatus = 'active' | 'upcoming' | 'past'

export interface CollectionData {
  id: number
  name: string
  status: CollectionStatus
  title: string
  description: string
  period: string
  countdownMessage?: string
  products: CollectionProduct[]
}

export const collectionsData: CollectionData[] = [
  {
    id: 1,
    name: '#1',
    status: 'active',
    title: 'ommi #1',
    description: '9 very unique products, every 4 months.',
    period: 'March 2026 - June 2026',
    countdownMessage: 'until Collection #2 arrives',
    products: [
      {
        id: 1,
        brand: 'James Navarra',
        name: 'Hammered Brass Candleholder',
        description: 'Hand-forged brass with intentional hammer marks. Each dent tells a story of the artisan\'s process.',
        material: 'Metals',
        price: '453',
        images: [
          '/images/mocks-products/brass-candleholder-hammer-marks.jpg',
          '/images/mocks-products/brass-candleholder-hammer-marks-2.png',
          '/images/mocks-products/brass-candleholder-hammer-marks-3.png',
          '/images/mocks-products/brass-candleholder-hammer-marks-4.png'
        ],
        status: 'available'
      },
      {
        id: 2,
        brand: 'Mario Crespo',
        name: 'Cracked Wooden Board',
        description: 'Reclaimed oak with natural cracks and character marks. The wood tells its own story through its imperfections.',
        material: 'Wood',
        price: '553',
        images: [
          '/images/mocks-products/wooden-board-natural-cracks.jpg',
          '/images/mocks-products/wooden-board-natural-cracks-2.png',
          '/images/mocks-products/wooden-board-natural-cracks-3.png',
          '/images/mocks-products/wooden-board-natural-cracks-4.png'
        ],
        status: 'available'
      },
      {
        id: 3,
        brand: 'Maria Stanislov',
        name: 'Warped Glaze Ceramic Plate',
        description: 'The kiln had its own ideas about this glaze. Sometimes the best pieces are the ones that didn\'t go according to plan.',
        material: 'Ceramics',
        price: '283',
        images: [
          '/images/mocks-products/ceramic-plate-warped-glaze.jpg',
          '/images/mocks-products/ceramic-plate-warped-glaze-2.png',
          '/images/mocks-products/ceramic-plate-warped-glaze-3.png'
        ],
        status: 'available'
      },
      {
        id: 4,
        brand: 'Enrico de la Cruz',
        name: 'Rough-Cut Marble Bookend',
        description: 'Carrara marble with intentionally rough-cut edges. The natural veining and imperfections make each piece unique.',
        material: 'Stone',
        price: '1783',
        images: [
          '/images/mocks-products/marble-bookend-rough-cut.jpg',
          '/images/mocks-products/marble-bookend-rough-cut-2.png',
          '/images/mocks-products/marble-bookend-rough-cut-3.png'
        ],
        status: 'available'
      },
      {
        id: 5,
        brand: 'Renée Morton',
        name: 'Irregular Woven Textile',
        description: 'Hand-loomed with intentional irregularities. Natural wool with visible knots and texture variations that tell the story of its making.',
        material: 'Fabrics and Leather',
        price: '353',
        images: [
          '/images/mocks-products/handwoven-textile-irregular-pattern.jpg',
          '/images/mocks-products/handwoven-textile-irregular-pattern-2.png',
          '/images/mocks-products/handwoven-textile-irregular-pattern-3.png'
        ],
        status: 'sold-out'
      },
      {
        id: 6,
        brand: 'Tren Baines',
        name: 'Bubbled Glass Vase',
        description: 'Trapped air bubbles create a constellation of imperfections. Each bubble is a moment frozen in time.',
        material: 'Glass',
        price: '653',
        images: [
          '/images/mocks-products/hand-blown-glass-vase-bubbles.jpg',
          '/images/mocks-products/hand-blown-glass-vase-bubbles-2.png',
          '/images/mocks-products/hand-blown-glass-vase-bubbles-3.png'
        ],
        status: 'available'
      },
      {
        id: 7,
        brand: 'Alex Chen',
        name: 'Handmade Cellulose Mega Sheets',
        description: 'Handcrafted paper with visible fiber textures and organic edges. Each sheet celebrates the natural imperfections of traditional papermaking.',
        material: 'Paper and Canvas',
        price: '423',
        images: [
          '/images/mocks-products/handmade-paper-artwork.jpg',
          '/images/mocks-products/handmade-paper-artwork-2.png',
          '/images/mocks-products/handmade-paper-artwork-3.png'
        ],
        status: 'available'
      },
      {
        id: 8,
        brand: 'Renée Morton',
        name: 'Very Big Garland',
        description: 'Handcrafted organic garland made from natural materials. Each piece celebrates the beauty of organic forms, with intentional variations that honor the natural growth patterns of the materials.',
        material: 'Organic',
        price: '425',
        images: [
          '/images/mocks-products/organic-garland-big.png',
          '/images/mocks-products/organic-garland-big-2.png',
          '/images/mocks-products/organic-garland-big-3.png',
          '/images/mocks-products/organic-garland-big-4.png'
        ],
        status: 'available'
      },
      {
        id: 9,
        brand: 'Sofia Martinez',
        name: '3D Printed Rock Sculpture (2m high)',
        description: 'Hand-molded composite material with intentional surface variations. The synthetic blend creates unique textures that celebrate industrial craftsmanship.',
        material: 'Plastic and Composites',
        price: '380',
        images: [
          '/images/mocks-products/composite-vessel-molded.jpg',
          '/images/mocks-products/composite-vessel-molded-2.png'
        ],
        status: 'available'
      },
      {
        id: 10,
        brand: 'David Kim',
        name: 'Precision Engineered Tool',
        description: 'Prototyped bike frame with visible fabrication marks. Each prototype bears the marks of its creation, celebrating the intersection of engineering precision and iterative design.',
        material: 'Engineering',
        price: '2790',
        images: [
          '/images/mocks-products/engineered-tool-precision.jpg',
          '/images/mocks-products/engineered-tool-precision-2.png',
          '/images/mocks-products/engineered-tool-precision-3.png'
        ],
        status: 'available'
      }
    ]
  }
]

export const defaultCollection = collectionsData[0]!

/** Current collection = season containing "now" in CET (1–4). Use with getCurrentSeasonIndex from data/seasons. */
export function getDefaultCollectionIdForSeason(seasonIndex: number): number {
  const id = Math.max(1, Math.min(4, Math.round(seasonIndex)))
  return collectionsData.some((c) => c.id === id) ? id : 1
}

export const findCollectionById = (id: number): CollectionData | undefined => {
  return collectionsData.find((collection) => collection.id === id)
}

